import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import UserEditForm from './Form';
import { getAccessUser } from "../../../services/auth";

class ModalDadosForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: JSON.parse(getAccessUser()),
    }
  }

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }))
  }

  render() {

    let closeBtn = '';
    let toggle = '';

    closeBtn = <button className="close" onClick={this.toggle}>&times;</button>
    toggle = this.toggle

    const label = this.props.buttonLabel

    let button = ''
    let title = ''
    let edit = ''

    if (label === 'NOVO') {
      button = <button
        className="btn btn-dommus-action"
        onClick={this.toggle}
        style={{ marginRight: "10px" }}>
        <i className="fa fa-plus-circle" aria-hidden="true"></i>{label}
      </button>
      title = 'Adicionar novo Cliente'
      edit = false
    } else {
      button = <p className="dropdown-item table-remove"
        to="#"
        onClick={this.toggle} style={{ width: "100px" }}>
        Editar <i style={{color: "blue"}} className="fas fa-edit"></i>
    </p>
      
      title = 'Editar Cliente'
      edit = true
    }

    return (
      <div>
        {button}
        <Modal isOpen={this.state.modal} toggle={toggle} className={this.props.className}>
          <ModalHeader toggle={toggle} close={closeBtn}>{title}</ModalHeader>
          <ModalBody>
            <UserEditForm
              toggle={toggle} edit={edit}
              juridicas={this.props.juridicas}
            />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}
export default ModalDadosForm